import { render, staticRenderFns } from "./zsbToStudy.vue?vue&type=template&id=7db187b1&scoped=true&"
import script from "./zsbToStudy.vue?vue&type=script&lang=js&"
export * from "./zsbToStudy.vue?vue&type=script&lang=js&"
import style0 from "./zsbToStudy.vue?vue&type=style&index=0&id=7db187b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db187b1",
  null
  
)

export default component.exports